export default {"src":"/_next/static/media/howItWorksIcon.5f4f69db.svg","height":17,"width":18};